/* wish-list.js.liquid - Enhanced Wishlist with Customer Account Integration - FIXED */

(function($) {
  
  // Wishlist Storage Key
  const WISHLIST_KEY = 'shopify_wishlist';
  
  // Initialize on page load
  $(document).ready(function() {
    initWishlist();
    initProductWishlist();
    initRemoveWishlist();
    updateWishlistCount();
    checkWishlistItems();
    initWishlistPage();
  });
  
  // Get customer ID if logged in - FIXED
  function getCustomerId() {
    // Check if customer data exists from Shopify Liquid
    if (window.shopify_customer && window.shopify_customer.logged_in && window.shopify_customer.id) {
      return window.shopify_customer.id.toString();
    }
    return null;
  }
  
  // Check if customer is logged in - FIXED
  function isCustomerLoggedIn() {
    // Direct check using Shopify customer data
    if (window.shopify_customer && window.shopify_customer.logged_in === true) {
      return true;
    }
    return false;
  }
  
  // Get wishlist from localStorage
  function getWishlist() {
    const customerId = getCustomerId();
    const key = customerId ? `${WISHLIST_KEY}_${customerId}` : WISHLIST_KEY;
    const wishlist = localStorage.getItem(key);
    return wishlist ? JSON.parse(wishlist) : [];
  }
  
  // Save wishlist to localStorage
  function saveWishlist(wishlist) {
    const customerId = getCustomerId();
    const key = customerId ? `${WISHLIST_KEY}_${customerId}` : WISHLIST_KEY;
    localStorage.setItem(key, JSON.stringify(wishlist));
    updateWishlistCount();
  }
  
  // Add product to wishlist
  function addToWishlist(productId, productTitle, productUrl, productImage, productPrice) {
    if (!isCustomerLoggedIn()) {
      showLoginRequired();
      return false;
    }
    
    const wishlist = getWishlist();
    const existingIndex = wishlist.findIndex(item => item.id === productId);
    
    if (existingIndex === -1) {
      wishlist.push({
        id: productId,
        title: productTitle,
        url: productUrl,
        image: productImage,
        price: productPrice,
        addedAt: new Date().toISOString()
      });
      
      saveWishlist(wishlist);
      showNotification('Product added to wishlist!', 'success');
      return true;
    } else {
      showNotification('Product already in wishlist!', 'info');
      return false;
    }
  }
  
  // Remove product from wishlist
  function removeFromWishlist(productId) {
    const wishlist = getWishlist();
    const filtered = wishlist.filter(item => item.id !== productId);
    saveWishlist(filtered);
    showNotification('Product removed from wishlist', 'success');
    return true;
  }
  
  // Check if product is in wishlist
  function isInWishlist(productId) {
    const wishlist = getWishlist();
    return wishlist.some(item => item.id === productId);
  }
  
  // Update wishlist count in header
  function updateWishlistCount() {
    const wishlist = getWishlist();
    const count = wishlist.length;
    
    $('.wishlist-count, .js-wishlist-count').text(count);
    
    if (count > 0) {
      $('.wishlist-count, .js-wishlist-count').show().addClass('show');
    } else {
      $('.wishlist-count, .js-wishlist-count').hide().removeClass('show');
    }
  }
  
  // Initialize wishlist buttons (product cards)
  function initWishlist() {
    $(document).on('click', '.engoj_add_to_wishlist, .js-add-to-wishlist', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const $btn = $(this);
      const productId = $btn.data('product-id') || $btn.attr('data-product-id');
      const productTitle = $btn.data('product-title') || $btn.attr('data-product-title');
      const productUrl = $btn.data('product-url') || $btn.attr('data-product-url');
      const productImage = $btn.data('product-image') || $btn.attr('data-product-image');
      const productPrice = $btn.data('product-price') || $btn.attr('data-product-price');
      
      if (!productId) {
        console.error('Product ID not found');
        return;
      }
      
      if (isInWishlist(productId)) {
        removeFromWishlist(productId);
        $btn.removeClass('active in-wishlist added');
        $btn.find('i').removeClass('fa-heart').addClass('fa-heart-o');
      } else {
        if (addToWishlist(productId, productTitle, productUrl, productImage, productPrice)) {
          $btn.addClass('active in-wishlist added');
          $btn.find('i').removeClass('fa-heart-o').addClass('fa-heart');
        }
      }
      
      checkWishlistItems();
    });
  }
  window.initWishlist = initWishlist;
  
  // Initialize product page wishlist button
  function initProductWishlist() {
    $(document).on('click', '.engoj_add_to_wishlist_pd, .js-add-to-wishlist-pd', function(e) {
      e.preventDefault();
      
      const $btn = $(this);
      const productId = $btn.data('product-id') || $btn.attr('data-product-id');
      const productTitle = $btn.data('product-title') || $btn.attr('data-product-title') || $('.product-title').text().trim();
      const productUrl = window.location.pathname;
      const productImage = $btn.data('product-image') || $btn.attr('data-product-image');
      const productPrice = $btn.data('product-price') || $btn.attr('data-product-price');
      
      if (!productId) {
        console.error('Product ID not found');
        return;
      }
      
      if (isInWishlist(productId)) {
        removeFromWishlist(productId);
        $btn.removeClass('active in-wishlist');
        $btn.find('span').text('Add to Wishlist');
      } else {
        if (addToWishlist(productId, productTitle, productUrl, productImage, productPrice)) {
          $btn.addClass('active in-wishlist');
          $btn.find('span').text('Added to Wishlist');
        }
      }
      
      checkWishlistItems();
    });
  }
  
  // Check and update wishlist button states
  function checkWishlistItems() {
    $('.engoj_add_to_wishlist, .js-add-to-wishlist').each(function() {
      const $btn = $(this);
      const productId = $btn.data('product-id') || $btn.attr('data-product-id');
      
      if (productId && isInWishlist(productId)) {
        $btn.addClass('active in-wishlist added');
        $btn.find('i').removeClass('fa-heart-o').addClass('fa-heart');
      } else {
        $btn.removeClass('active in-wishlist added');
        $btn.find('i').removeClass('fa-heart').addClass('fa-heart-o');
      }
    });
    
    $('.engoj_add_to_wishlist_pd, .js-add-to-wishlist-pd').each(function() {
      const $btn = $(this);
      const productId = $btn.data('product-id') || $btn.attr('data-product-id');
      
      if (productId && isInWishlist(productId)) {
        $btn.addClass('active in-wishlist');
        $btn.find('span').text('Added to Wishlist');
      } else {
        $btn.removeClass('active in-wishlist');
        $btn.find('span').text('Add to Wishlist');
      }
    });
  }
  
  // Initialize wishlist page functionality
  function initWishlistPage() {
    if (!$('.wishlist-page, .page-wishlist').length) return;
    
    renderWishlistPage();
    
    // Remove from wishlist
    $(document).on('click', '.js-remove-wishlist, .btn-remove-wishlist, .engoc-remove-item-wishlist', function(e) {
      e.preventDefault();
      
      const $btn = $(this);
      const productId = $btn.data('product-id') || $btn.attr('data-product-id') || $btn.closest('tr').attr('id').replace('product-', '');
      
      if (confirm('Are you sure you want to remove this item from your wishlist?')) {
        removeFromWishlist(productId);
        $btn.closest('tr, .wishlist-item').fadeOut(300, function() {
          $(this).remove();
          renderWishlistPage();
        });
      }
    });
    
    // Clear all wishlist
    $(document).on('click', '.js-clear-wishlist', function(e) {
      e.preventDefault();
      
      if (confirm('Are you sure you want to clear your entire wishlist?')) {
        saveWishlist([]);
        renderWishlistPage();
        showNotification('Wishlist cleared', 'success');
      }
    });
  }
  
  // Render wishlist page
  function renderWishlistPage() {
    const wishlist = getWishlist();
    const $container = $('.wishlist-items-container');
    
    if (!$container.length) return;
    
    if (wishlist.length === 0) {
      $container.html(`
        <div class="wishlist-empty text-center" style="padding: 80px 20px;">
          <h3 style="font-size: 24px; margin-bottom: 10px;">Your wishlist is empty</h3>
          <p style="color: #6c757d; margin-bottom: 25px;">Save your favorite items here to view them later</p>
          <a href="/collections/all" class="btn btn-primary">Start Shopping</a>
        </div>
      `);
      $('.wishlist-actions').hide();
      return;
    }
    
    $('.wishlist-actions').show();
    
    let html = '<div class="wishlist-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 25px;">';
    
    wishlist.forEach(item => {
      html += `
        <div class="wishlist-item" data-product-id="${item.id}" style="background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
          <div style="position: relative; padding-top: 100%; background: #f8f9fa;">
            <a href="${item.url}">
              <img src="${item.image}" alt="${item.title}" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;">
            </a>
            <button class="js-remove-wishlist" data-product-id="${item.id}" style="position: absolute; top: 10px; right: 10px; width: 36px; height: 36px; background: rgba(220,53,69,0.9); color: white; border: none; border-radius: 50%; cursor: pointer;">
              <i class="ti-close"></i>
            </button>
          </div>
          <div style="padding: 20px;">
            <h3 style="margin: 0 0 10px 0; font-size: 16px;">
              <a href="${item.url}" style="color: #1a1a1a; text-decoration: none;">${item.title}</a>
            </h3>
            <div style="font-size: 18px; font-weight: 700; color: #003a8fe6; margin-bottom: 15px;">${item.price}</div>
            <a href="${item.url}" class="btn btn-primary btn-sm" style="display: block; text-align: center; padding: 10px; background: #003a8fe6; color: white; border-radius: 8px; text-decoration: none;">View Product</a>
          </div>
        </div>
      `;
    });
    
    html += '</div>';
    
    $container.html(html);
    $('.wishlist-total-count').text(wishlist.length);
  }
  
  // Remove wishlist - keep for backwards compatibility
  function initRemoveWishlist() {
    // Already handled in initWishlistPage
  }
  
  // Show login required message
  function showLoginRequired() {
    // Redirect to login with return URL
    const returnUrl = encodeURIComponent(window.location.pathname);
    window.location.href = `/account/login?return_url=${returnUrl}`;
  }
  
  // Show notification
  function showNotification(message, type) {
    type = type || 'info';
    $('.wishlist-notification').remove();
    
    const notification = $(`
      <div class="wishlist-notification wishlist-notification-${type}">
        <span class="notification-message">${message}</span>
        <button class="notification-close">&times;</button>
      </div>
    `);
    
    $('body').append(notification);
    
    setTimeout(() => notification.addClass('show'), 100);
    setTimeout(() => {
      notification.removeClass('show');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
    
    notification.find('.notification-close').on('click', function() {
      notification.removeClass('show');
      setTimeout(() => notification.remove(), 300);
    });
  }
  
  // Handle wishlist header icon click - REMOVED (let link work naturally)
  // The link itself now handles logged in vs logged out states
  
  // Export functions
  window.WishlistManager = {
    add: addToWishlist,
    remove: removeFromWishlist,
    get: getWishlist,
    isInWishlist: isInWishlist,
    updateCount: updateWishlistCount,
    check: checkWishlistItems,
    isLoggedIn: isCustomerLoggedIn
  };
  
})(jQuery);
